import { LitElement, html, css } from "lit";

class MatterNewsList extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
        font-family: Source Sans Pro, sans-serif;

        --main-hover: #0b4c1a;
        --main: #087021;

        --theme: #087021;
        --gray: #333333;
        --line: #c4c4c4;
      }

      :host([detail_hidden]) .detail {
        display: none;
      }

      span,
      a {
        color: var(--theme);
        text-decoration: none;
        font-weight: 400;
      }

      .title {
        margin-bottom: 2.1875rem;
        font-size: 1.25rem;
        font-weight: bold;
        color: var(--gray);
      }

      .container {
        display: flex;
        flex-direction: column;
        margin-bottom: 1.125rem;
        max-width: 395px;
      }
      hr {
        border: 1px solid var(--line);
      }

      .date span {
        display: block;
        font-size: 15px;
        line-height: 19px;
        color: var(--gray);
         font-weight: 550;
      }

      .text {
         font-weight: 550;
        font-size: 17px;
        line-height: 21px;
        color: var(--main);
        margin-bottom: 0; // Modificacion 25-11-2022
        margin-top: 0; // Modificacion 25-11-2022
      }

      .detail a {
        font-size: 0.875rem;
        font-weight: bold;
        line-height: 1.1875rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    `;
  }

  static get properties() {
    return {
      title: { type: String },
      events: { type: String },
      max: { type: Number },
      lang: { type: String },
      order: { type: String },
      detail_name: { type: String },
      detail_url: { type: String },
      detail_hidden: { type: Boolean, reflect: true },
      inputDate: { type: String },
      inputUrl: { type: String },
      inputTitle: { type: String },

      _response: { type: Array },
      _error: { type: String },

      busyIndicator: { type: Object },
    };
  }

  constructor() {
    super();
    this.title = "";
    this.events = "";
    this.max = 3;
    this.lang = "";
    this.order = "asc";
    this.detail_name = "";
    this.detail_url = "";
    this.detail_hidden = false;
    this.inputDate = "";
    this.inputTitle = "";
    this.inputUrl = "";

    this._response = [];
    this._error = "";

    this.busyIndicator = {};
  }

  render() {
    return html`
      ${this._error
        ? html` <div>${this._error}</div> `
        : html`
            <div class="container">
              ${this.title.length > 0
                ? html`<div class="title">${this.title}</div>`
                : ""}
              ${this._response.map(
                (event) =>
                  html`
                    <div class="news">
                      <hr />
                      <!-- Modificaciones 25-11-2022 Start -->
                      ${event.url
                        ? html`<a
                            href=${event.url}
                            title=${event.title}
                            target="_blank"
                            rel="noopener noreferrer"
                            class="text"
                            >${event.title}</a
                          >`
                        : html`<p class="text">${event.title}</p>`}
                      <!-- Modificaciones 25-11-2022 End -->
                      <div class="date">
                        ${this.getDate(event.date).map(
                          (date) => html` <span>${date}</span> `
                        )}
                      </div>
                    </div>
                  `
              )}

              <div class="detail">
                <a
                  href=${this.detail_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title=${this.detail_name}
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-plus-circle"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 8v8M8 12h8" />
                  </svg>
                  ${this.detail_name}</a
                >
              </div>
            </div>
          `}
    `;
  }

  addFont() {
    const sourceSans = document.createElement("link");
    sourceSans.href =
      "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap";
    sourceSans.rel = "stylesheet";
    document.head.append(sourceSans);
  }

  firstUpdated() {
    this.addFont();
  }

  // updated(changedProperties) {
  //   changedProperties.forEach((_, propName) => {
  //     if (
  //       [
  //         "events",
  //         "order",
  //         "max",
  //         "lang",
  //         "inputDate",
  //         "inputUrl",
  //         "inputTitle",
  //       ].includes(propName)
  //     ) {
  //       this.updatedResponse();
  //     }
  //   });
  // }

  // updatedResponse() {
  //   this._error = null;
  //   fetch(this.events)
  //     .then((response) => {
  //       if (response.ok) {
  //         response
  //           .json()
  //           .then((responseJSON) => {
  //             const elements = [];
  //             // Recorro los distintos objetos en busca de los atributos
  //             responseJSON.forEach((item) => {
  //               const url = item[this.inputUrl] ? item[this.inputUrl] : "";
  //               const date = item[this.inputDate] ? item[this.inputDate] : "";
  //               const title = item[this.inputTitle]
  //                 ? item[this.inputTitle]
  //                 : "";
  //               elements.push({
  //                 date,
  //                 url,
  //                 title,
  //               });
  //             });

  //             this._response = elements;
  //             this._response.length = Math.min(this.max, this._response.length);
  //           })
  //           .catch((error) => {});
  //       }
  //     })
  //     .catch((error) => {});
  // }

  getDate(date) {
    const result = [];
    var options = { month: "long", day: "numeric" };
    if (date) {
      const fecha = new Date(date);
      result.push(fecha.toLocaleDateString(this.lang, options));
    }
    return result;
  }

  // Async
  async respuesta() {
    this._error = null;

    await new Promise((resolve) => setTimeout(resolve, 0));
    this.busyIndicator.active = true; // This is a component on the page
    try {
      const response = await fetch(this.events);
      const data = await response.json();
      const elements = [];

      data.forEach((item) => {
        const url = item[this.inputUrl] ? item[this.inputUrl] : "";
        const date = item[this.inputDate] ? item[this.inputDate] : "";
        const title = item[this.inputTitle] ? item[this.inputTitle] : "";
        elements.push({
          date,
          url,
          title,
        });
      });

      this._response = elements;
      this._response.length = Math.min(this.max, this._response.length);
    } catch (err) {
    } finally {
      this.busyIndicator.active = false;
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.respuesta();
  }

  // sorting(events) {
  //   const results = events.sort((date1, date2) => {
  //     const fecha = (a) =>
  //       a.date
  //         .split("/")
  //         .map((b) => `0${b}`.slice(-2))
  //         .reverse()
  //         .join("");

  //     const dateA = fecha(date1);
  //     const dateB = fecha(date2);

  //     if (this.order === "desc") {
  //       return dateB.localeCompare(dateA);
  //     }

  //     return dateA.localeCompare(dateB);
  //   });
  //   // console.log("Results: ", results);

  //   // results.length = Math.min(this.max, results.length);
  //   // console.log(results.length);
  //   return results;
  // }
}

if (!window.customElements.get("matter-news-list")) {
  window.customElements.define("matter-news-list", MatterNewsList);
}
